module.exports = __webpack_public_path__ + "static/img/step3.e1d263b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step3.png
// module id = yIMT
// module chunks = 128